export const DraggableItemIds = {
  CALL_CONTROLS: 'callControls',
} as const;
